import React, { useState } from "react";
import { Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Header.scss";

function Header() {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuItemClick = (path) => {
    navigate(path);
    setIsDropdownOpen(false);
  };

  return (
    <div
      className="header-container"
      onMouseEnter={() => setIsDropdownOpen(true)}
      onMouseLeave={() => setIsDropdownOpen(false)}
    >
      <Navbar expand="lg" className="bg-body-tertiary header">
        <div
          className="dropdown-logo"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <img
            src="/images/logo.png"
            alt="Logo"
            height="32"
            style={{
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none"
            }}
            onMouseDown={(e) => e.preventDefault()}
          />
        </div>
      </Navbar>

      <div className={`dropdown-menu-container ${isDropdownOpen ? "open" : ""}`}>
        <div className="dropdown-item-custom">
          <a href="/form" onClick={(e) => { e.preventDefault(); handleMenuItemClick("/form"); }}>
            Formulare
          </a>
        </div>
        <div className="dropdown-item-custom">
          <a href="/" onClick={(e) => { e.preventDefault(); handleMenuItemClick("/"); }}>
            Petitii
          </a>
        </div>
      </div>
    </div>
  );
}

export default Header;